import { createApi } from '@reduxjs/toolkit/query/react';

import { ResponseDataInterface } from '@interface/logs/response-data.interface';
import {
  ApplicationDetailedStatsChartInterface,
  ApplicationStatsChartInterface,
  ApplicationStatsInterface,
  ConsumerStatsInterface,
} from '@interface/stats/stats.interface';
import { portalQueryAuth } from '@util/api/portal-query-auth';

export const statsApi = createApi({
  reducerPath: 'stats-api',
  baseQuery: portalQueryAuth('/stats'),
  endpoints: (build) => ({
    loadApplicationStats: build.query<ResponseDataInterface<ApplicationStatsInterface>, string>({
      query: (applicationId) => `/application/${applicationId}`,
    }),
    loadConsumerStats: build.query<ResponseDataInterface<ConsumerStatsInterface>, string>({
      query: (consumerId) => `/consumer/${consumerId}`,
    }),
    loadApplicationChartStats: build.query<ResponseDataInterface<ApplicationStatsChartInterface[]>, string>({
      query: (applicationId) => `/application/${applicationId}/chart`,
    }),
    loadApplicationDetailedChartStats: build.query<
      ResponseDataInterface<ApplicationDetailedStatsChartInterface[]>,
      string
    >({
      query: (applicationId) => `/application/${applicationId}/chart/detailed`,
    }),
  }),
});
